// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M14 4.25C14 5.77 11.31 7 8 7C4.69 7 2 5.77 2 4.25C2 2.73 4.69 1.5 8 1.5C11.31 1.5 14 2.73 14 4.25Z',
  'M2 4.25V11.75C2 13.27 4.69 14.5 8 14.5C11.31 14.5 14 13.27 14 11.75V4.25',
  'M2 8C2 9.52 4.69 10.75 8 10.75C11.31 10.75 14 9.52 14 8',
];
